import { jobStateEnum } from '@/api/job';
import { useTabKeyStore } from '@/utils/bottomTabsKeyStore';
import { Job, useJobStore } from '@/utils/jobService';
import { CheckSquareOutlined, ClockCircleOutlined, CloseOutlined, EnterOutlined, LoadingOutlined, WarningOutlined } from '@ant-design/icons';
import type { TabsProps } from 'antd';
import { Button, Tabs } from 'antd';
import OutputDisplay from './ouputDisplay';
import { useEffect } from 'react';
import useFileStore from '@/utils/fileStore';
import pathbe from 'path-browserify-esm';

const OutputTabs = () => {
    const jobs = useJobStore(state => state.jobs);
    useEffect(() => {
        console.log("jobs:", jobs);
    }, [jobs]);
    const items: TabsProps['items'] = Object.keys(jobs).map((key) => {
        const job = jobs[key];
        return {
            key: key,
            label: job.job_name,
            children: <OutputDisplay job={job} />,
        };
    });
    const outputTabsActiveKey = useTabKeyStore(state => state.outputTabsActiveKey);
    const setOutputTabsActiveKey = useTabKeyStore(state => state.setOutputTabsActiveKey);

    useEffect(() => {
        console.log("outputTabsActiveKey changed:", outputTabsActiveKey);
    }, [outputTabsActiveKey]);

    const handleChange = (key: string) => {
        console.log("Tab changed to:", key);
        setOutputTabsActiveKey(key);
    };

    const itemIcon = (state: jobStateEnum) => {
        switch (state) {
            case jobStateEnum.PENDING:
                return <ClockCircleOutlined />;
            case jobStateEnum.RUNNING:
                return <LoadingOutlined />;
            case jobStateEnum.COMPLETE:
                return <CheckSquareOutlined />;
            case jobStateEnum.FAILED:
                return <WarningOutlined />;
            case jobStateEnum.CANCELED:
                return <CloseOutlined />;
            default:
                return null;
        }
    }

    const removeJob = useJobStore(state => state.removeJob);

    const closeOutput = (job: Job) => {
        removeJob(job);
        if (job.tag === outputTabsActiveKey) {
            const remainingKeys = Object.keys(jobs).filter(key => key !== job.tag);
            if (remainingKeys.length > 0) {
                setOutputTabsActiveKey(remainingKeys[0]);
            } else {
                setOutputTabsActiveKey(undefined); // Reset to default or empty if no jobs left
            }
        }
    }

    const navigateToFile = useFileStore(state => state.navigateToFile);

    return (
        <div className={`shadow-sm border h-full overflow-hidden flex flex-row border-gray-200 dark:border-[#404040]`}>
            <Tabs
                activeKey={outputTabsActiveKey}
                items={items}
                renderTabBar={() => <></>}
                onChange={handleChange}
                className=" flex-1 overflow-hidden"
                tabBarStyle={{ marginBottom: 0 }}
                type="card"
            />
            <div className=' w-36'>
                <div className="border-l border-gray-200 dark:border-[#404040] flex flex-col h-full overflow-y-auto bg-gray-50 dark:bg-[#1E1E1E]">
                    {items.map((item) => (
                        <div
                            key={item.key}
                            className={`flex items-center justify-between px-2 hover:bg-gray-200 dark:hover:bg-[#333333] rounded mb-1 cursor-pointer transition-colors duration-200 ${outputTabsActiveKey === item.key ? 'bg-blue-100 dark:bg-[#0E639C]' : ''}`}
                            onClick={() => setOutputTabsActiveKey(item.key as string)}
                        >
                            <div className="flex items-center overflow-hidden">
                                <div className="mr-2 flex-shrink-0">
                                    {itemIcon(jobs[item.key].state)}
                                </div>
                                <span className="text-sm truncate max-w-24" title={jobs[item.key].job_name}>
                                    {jobs[item.key].job_name}
                                </span>
                            </div>
                            {jobs[item.key].state === jobStateEnum.COMPLETE && <Button
                                type="text"
                                className="flex-shrink-0 p-0"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    console.log(jobs[item.key]);
                                    const job = jobs[item.key];
                                    const outputfileName = `${job.job_name}.${job.id_job}.out`;
                                    const outputfilePath = pathbe.join(pathbe.dirname(job.path), outputfileName);
                                    navigateToFile(outputfilePath);
                                }}
                            >
                                <EnterOutlined />
                            </Button>}
                            <Button
                                type="text"
                                className="flex-shrink-0 p-0"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeOutput(jobs[item.key]);
                                }}
                            >
                                <CloseOutlined />
                            </Button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default OutputTabs;